import EventEmitter from 'es6-eventemitter';

export default class JobsService {

    constructor(http){
        this.http = http;
        this.events = new EventEmitter();
    }

    getAllUsers(){
        return this.http.get('api/users');
    }

    approveUser(id){
        return this.http.post('api/users/approve', { id });
    }

    rejectUser(id){
        return this.http.post('api/users/reject', { id });
    }

    updateAccessLevel(id, accessLevel){
        return this.http.post('api/users/access-level', { id, access_level: accessLevel})
    }

    deleteUser(id){
        return this.http.delete('api/users', { body: { id } });
    }

}


// WEBPACK FOOTER //
// ./src/services/users.service.js